// Analytics-specific action types
export const SET_ANALYTICS_DATA = 'SET_ANALYTICS_DATA';
export const SET_USAGE_METRICS_DATA = 'SET_USAGE_METRICS_DATA';

// Analytics-specific action interfaces
export interface ISetAnalyticsDataAction {
  type: typeof SET_ANALYTICS_DATA;
  payload: IAnalyticsDataItem[];
}

export interface ISetUsageMetricsDataAction {
  type: typeof SET_USAGE_METRICS_DATA;
  payload: IUsageMetricsDataItem[];
}

export type AnalyticsActionTypes = ISetAnalyticsDataAction | ISetUsageMetricsDataAction;

export interface IAnalyticsDataItem {
  totalAmount: number;
  date: string;
  count: number;
}

export interface IUsageMetricsDataItem {
  daily_bucket?: string;
  six_hour_bucket?: string; // Keep for backward compatibility
  usage_count: number;
  total_prompt_tokens: number;
  total_completion_tokens: number;
  total_reasoning_tokens: number;
  total_cost: number;
}
